<template>
  <v-container class="background-gray pt-0">
    <v-row class="pa-2">
      <v-col cols="12" class="headline pl-5">CHECKLIST COMPLETADOS</v-col>
      <v-col cols="12" class="text-h4 pl-5 py-0" v-if="$route.query.user"
        >Usuario: <strong>{{ nameUser }}</strong></v-col
      >
    </v-row>
    <v-row wrap class="pl-5 pr-5">
      <v-col
        cols="12"
        md="6"
        lg="4"
        class="pb-0"
        v-for="(pedido, index) in checklistOrders"
        :key="index"
      >
        <v-card class="elevation-0" outlined>
          <v-container class="pa-0 pl-2 pr-2">
            <v-row align="center">
              <v-col cols="7" class="pt-1 pb-1">
                <span class="body-2 font-weight-regular"
                  >Nº Pedido: {{ pedido.saleOrderID }}</span
                >
                <template v-if="pedido.eventType != 'traspasos'">
                  <br />
                  <span class="body-2 font-weight-regular"
                    >Nº Orden: {{ pedido.productID }}</span
                  >
                </template>
                <br />
                <span class="body-2 font-weight-regular"
                  >Proceso: {{ pedido.eventType }}</span
                >
                <br />
                <span class="body-2 font-weight-regular"
                  >Estatus: {{ pedido.statusType }}</span
                >
                <br />
                <div class="caption font-weight-light">
                  Fecha Completado: {{ pedido.completed | compactDate }}
                </div>
              </v-col>
              <v-col cols="5" class="text-right" justify="center">
                <v-btn
                  class="black--text"
                  small
                  block
                  color="accent"
                  @click="
                    checklistDetail(
                      pedido.pID,
                      pedido.eventType,
                      pedido.statusType,
                      pedido.oID ? pedido.oID : pedido.saleOrderID,
                      pedido
                    )
                  "
                  >Ver Checklist</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="12" class="text-center">
        <v-progress-circular
          v-show="loadingMoreOrders"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-col>
      <template v-if="checklistOrders">
        <v-col
          v-if="!checklistOrders.length && !loadingMoreOrders"
          cols="12"
          class="text-center"
          >No se han encontrado checklist completados</v-col
        >
        <v-col
          v-if="checklistOrders.length > 1 && notMoreProducts"
          cols="12"
          class="text-center"
          >No hay mas checklist</v-col
        >
      </template>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import { largeDateNumbersStringFilter } from "@/filters";
import { loaderDone, loaderStart } from "@/services/LoaderService";

export default {
  data() {
    return {
      loadingMoreOrders: false,
      totalChecklist: 0,
      checklistsData: null,
      checklistOrders: [],
      notMoreProducts: false,
      pagination: 0,
      nameUser: ""
    };
  },
  async created() {
    loaderStart();
    window.addEventListener("scroll", this.lazyLoad);
    this.nameUser = await this.getNameUser(this.$route.query.user);
    const checklistsData = await this.getChecklistCompleted(this.$route.query);
    if (checklistsData) {
      this.totalChecklist = checklistsData.length;
      this.checklistsData = checklistsData;
      this.loadingOrders(this.checklistsData, 0, 10);
    } else {
      this.loadingMoreOrders = false;
      this.notMoreProducts = true;
      loaderDone();
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.lazyLoad);
    loaderDone();
  },
  methods: {
    ...mapActions("user", ["getNameUser"]),
    ...mapActions("checklist", ["getChecklistCompleted", "getSingleOrder"]),
    async loadingOrders(checklistArray, to, from) {
      this.loadingMoreOrders = true;
      this.pagination = this.pagination + 10;
      const orderData = await this.getSingleOrder(
        checklistArray.slice(to, from)
      );
      if (orderData) {
        orderData.forEach(order => {
          this.checklistOrders.push(order);
        });
      } else {
        this.notMoreProducts = true;
      }
      if (this.checklistsData.length < 10) this.notMoreProducts = true;
      this.loadingMoreOrders = false;
      loaderDone();
    },
    checklistDetail(productID, queryEvent, queryType, id, orderData) {
      if (queryEvent === "traspasos") {
        this.$router.push({
          name: "transfer-checklist",
          params: {
            id,
            event: queryType,
            action: "detalle"
          }
        });
      } else {
        this.$router.push({
          name: "checklist",
          params: {
            id,
            productID,
            event: queryEvent,
            type: queryType
          },
          query: {
            order: orderData.productID,
            saleOrderID: orderData.saleOrderID,
            machineSerie: orderData.machineSerie,
            event: this.translateStatus(`${queryEvent}${queryType}`, true),
            inputOuput: this.translateStatus(
              `${queryEvent}${queryType}`,
              false
            ),
            statusID: orderData.status,
            typeAction: "consult",
            backUrlSearch: this.$router.currentRoute.fullPath
          }
        });
      }
    },
    async lazyLoad() {
      // :: Create a variable to know when the scroll position is at the bottom of the page.
      const scrollIsAtTheBottom =
        Math.abs(
          document.documentElement.scrollHeight -
            window.innerHeight -
            window.scrollY
        ) <= 1;

      if (scrollIsAtTheBottom) {
        const length = this.checklistsData ? this.checklistsData.length : 0;
        if (this.pagination < length)
          this.loadingOrders(
            this.checklistsData,
            this.pagination,
            this.pagination + 10
          );
        else this.notMoreProducts = true;
      }
    },
    translateStatus(status, option) {
      switch (status) {
        case "deliveryoutput":
          return option ? "Entrega" : "S";
        case "maintenanceoutput":
          return option ? "Mantenimiento" : "S";
        case "relocationoutput":
          return option ? "Reubicación" : "S";
        case "recollectionoutput":
          return option ? "Recolección" : "S";
        case "rented-serviceoutput":
          return option ? "Rentado Servicio" : "S";
        // :: Input status filters
        case "deliveryinput":
          return option ? "Entrega" : "E";
        case "maintenanceinput":
          return option ? "Mantenimiento" : "E";
        case "relocationinput":
          return option ? "Reubicación" : "E";
        case "recollectioninput":
          return option ? "Recolección" : "E";
        case "rented-serviceinput":
          return option ? "Rentado Servicio" : "E";
        default:
          return { onlyLetter: "N/A", name: "No hay checklists activos" };
      }
    }
  },
  filters: {
    compactDate: largeDateNumbersStringFilter
  }
};
</script>

<style>
.combo {
  font-weight: 400;
}
.caption {
  font-weight: 300;
}
.combo i.v-icon.notranslate.material-icons.theme--light {
  color: #ffcd00 !important;
}

/* Style Overflow buttons */
.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: unset;
}
.v-overflow-btn .v-input__control::before {
  height: 0px;
}
.v-overflow-btn .v-select__selection--comma:first-child {
  margin-left: 6px;
}
</style>
